import {Component} from "react";
import React from "react";
import FileUpload from "./FileUpload";

class Input extends Component {
    state = {
        text: ""
      }
      onChange(e) {
        this.setState({text: e.target.value});
      }
      onSubmit(e) {
        e.preventDefault();
        let xhr = new XMLHttpRequest();
        xhr.withCredentials = true; 
        let texto = this.state.text;
        let access_token = sessionStorage.getItem("access_token");
        let user_id = sessionStorage.getItem("user_id");
        let my_user_id = sessionStorage.getItem("my_user_id");
        let secure_email = sessionStorage.getItem("secure_email");
        let order_id = sessionStorage.getItem("order_id");
        let url = "https://api.mercadolibre.com/messages?access_token=" + access_token;
        let jsn;
        if (!sessionStorage.id) {
          jsn = JSON.stringify(
          {
            "from" : {
              "user_id": my_user_id, 
              "email" : secure_email
            },
            "to":[{
              "user_id" : user_id,
              "resource": "orders",
		          "resource_id": order_id,
              "site_id": "MLC" 
                  }],
            "text": {"plain": texto}
        });
        }else{
          jsn = JSON.stringify({
            "attachments": [sessionStorage.id],
            "from" : {
              "user_id": my_user_id, 
              "email" : secure_email
            },
            "to":[{
              "user_id" : user_id,
              "resource": "orders",
		          "resource_id": order_id,
              "site_id": "MLC" 
                  }],
            "text":{
              "plain": texto
              }
          });
        }
        console.log(jsn);
        xhr.open("POST", url);
        xhr.setRequestHeader("content-type", "application/json");
        xhr.send(jsn);
        this.setState({text: ""});
      }
      render() {
        return (
        <form onSubmit={e => this.onSubmit(e)} >
          <div className="input-group">
              <input className="form-control"
                onChange={e => this.onChange(e)}
                value={this.state.text}
                type="text"
                placeholder="Ingrese su mensaje"
              />
              <span className="input-group-btn glyphicon glyphicon-upload">
                <FileUpload/>
                </span>
              <span className="input-group-btn">
                <button type="submit" className="btn btn-default">Enviar</button>  
              </span>
          </div>
        </form>
  
        );
      }
}

export default Input;